<div class="md:h-full">
  <aipb-inside-loading [loading]="loading$ | async"></aipb-inside-loading>

  <dg-collection
    [breadcrumbs]="breadcrumbs$ | async"
    [collections]="collections$ | async"
    [records]="records$ | async"
    [rootCollections]="rootCollections$ | async"
  ></dg-collection>

  <dg-record
    [breadcrumbs]="breadcrumbs$ | async"
    [collectionLabel]="collectionLabel$ | async"
    [items]="records$ | async"
    [pagination]="pagination$ | async"
  ></dg-record>
</div>
